module.exports = __webpack_public_path__ + "static/media/audio.3e6b86e6.svg";